export default ({ request }) => ({
  ecomAmzFlipOrderListApi(data = {}) {
    return request({
      url: '/ecom/amz/flip/order/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzFlipOrderSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/flip/order/save',
      method: 'POST',
      data,
      timeout: 30000,
    })
  },
  ecomAmzFlipOrderAppendSpuApi(data = {}) {
    return request({
      url: '/ecom/amz/flip/order/append/spu',
      method: 'POST',
      data,
      timeout: 30000,
    })
  },
  ecomAmzFlipOrderDelSpuApi(data = {}) {
    return request({
      url: '/ecom/amz/flip/order/del/spu',
      method: 'POST',
      data,
      timeout: 30000,
    })
  },
  ecomAmzFlipOrderDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/flip/order/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzFlipOrderDelApi(data = {}) {
    return request({
      url: '/ecom/amz/flip/order/del',
      method: 'POST',
      data,
    })
  },
  ecomAmzFlipOrderReviewApi(data = {}) {
    return request({
      url: '/ecom/amz/flip/order/review',
      method: 'POST',
      data,
    })
  },
  ecomAmzFlipOrderPurchaseRejectionApi(data = {}) {
    return request({
      url: '/ecom/amz/flip/order/purchase/rejection',
      method: 'POST',
      data,
    })
  },
  ecomAmzFlipOrderApprovedApi(data = {}) {
    return request({
      url: '/ecom/amz/flip/order/approved',
      method: 'POST',
      data,
    })
  },
  ecomAmzFlipOrderReviewRejectionApi(data = {}) {
    return request({
      url: '/ecom/amz/flip/order/review/rejection',
      method: 'POST',
      data,
    })
  },
  ecomAmzFlipOrderGeneratePurchaseApi(data = {}) {
    return request({
      url: '/ecom/amz/flip/order/generate/fty/purchase',
      method: 'POST',
      data,
    })
  },
  ecomAmzFlipOrderSkuListApi(data = {}) {
    return request({
      url: '/ecom/amz/flip/order/sku/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzFlipOrderSkuSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/flip/order/sku/save',
      method: 'POST',
      data,
    })
  },
  ecomAmzFlipOrderSkuDelApi(data = {}) {
    return request({
      url: '/ecom/amz/flip/order/sku/del',
      method: 'POST',
      data,
    })
  },
  ecomAmzFlipOrderSkuSaveConfirmApi(data = {}) {
    return request({
      url: '/ecom/amz/flip/order/sku/save/confirm',
      method: 'POST',
      data,
    })
  },
  ecomAmzFlipOrderSkuSaveSubmitApi(data = {}) {
    return request({
      url: '/ecom/amz/flip/order/sku/save/submit',
      method: 'POST',
      data,
    })
  },
  ecomAmzFlipOrderSkuReviewApi(data = {}) {
    return request({
      url: '/ecom/amz/flip/order/sku/review',
      method: 'POST',
      data,
    })
  },
  ecomAmzFlipOrderSkuCountApi(data = {}) {
    return request({
      url: '/ecom/amz/flip/order/sku/count',
      method: 'POST',
      data,
    })
  },
  ecomAmzFlipOrderSkuDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/flip/order/sku/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzFlipOrderSkuMoqConfirmApi(data = {}) {
    return request({
      url: '/ecom/amz/flip/order/sku/moq/confirm',
      method: 'POST',
      data,
    })
  },
  ecomAmzFlipOrderSkuMoqConfirmPCardListApi(data = {}) {
    return request({
      url: '/ecom/amz/flip/order/sku/moq/confirm/pcardList',
      method: 'POST',
      data,
    })
  },
  ecomAmzFlipOrderSkuConfirmOrderApi(data = {}) {
    return request({
      url: '/ecom/amz/flip/order/sku/confirm/order',
      method: 'POST',
      data,
    })
  },
  ecomAmzFlipOrderMarketListApi(data = {}) {
    return request({
      url: '/ecom/amz/flip/order/market/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzFlipOrderSpuListApi(data = {}) {
    return request({
      url: '/ecom/amz/flip/orde/spu/list',
      method: 'POST',
      data,
    })
  },
})
